import {
  GRANT_CLOSED_MODES,
  GRANT_SORTS,
  type GrantClosedMode,
  type GrantSort,
} from '@zoxo/shared';

import type { GrantFilters } from './use-grants';

/**
 * 유형 전용 화면의 검색 파라미터.
 *
 * **`support` 를 안 읽는다.** 유형은 주소가 정하므로, `?support=` 가 붙어
 * 와도 무시한다 — 안 그러면 `/loans?support=subsidy` 라는 자기모순 주소가
 * 생기고 어느 쪽이 이기는지 화면마다 달라진다.
 *
 * `/news` 의 `validateSearch` 와 **같은 정규화**를 한다. 다르면 같은 쿼리가
 * 두 화면에서 다른 캐시 키를 만들어 조용히 미스가 난다.
 */
export function grantTypeSearch(search: Record<string, unknown>): GrantFilters {
  const sort = search.sort;
  return {
    region: typeof search.region === 'string' && search.region ? search.region : undefined,
    field: typeof search.field === 'string' && search.field ? search.field : undefined,
    closed:
      typeof search.closed === 'string' &&
      (GRANT_CLOSED_MODES as readonly string[]).includes(search.closed) &&
      search.closed !== 'exclude'
        ? (search.closed as GrantClosedMode)
        : undefined,
    sort:
      typeof sort === 'string' && (GRANT_SORTS as readonly string[]).includes(sort)
        ? (sort as GrantSort)
        : undefined,
    q: typeof search.q === 'string' && search.q.trim() ? search.q.trim().slice(0, 60) : undefined,
    // 프로그램 하위 종류는 검색 파라미터가 아니라 주소(/news/programs/<slug>)다 — routes/news.programs.$kind.
  };
}
